<template>
  <div v-bind:class="{row: !inner}">

  <!--
    <div v-if="invoiceId" data-notify="container" class="col-md-12 alert alert-success alert-with-icon">
      <span data-notify="icon" class="fa fa-file-text-o"></span>
      <div data-notify="message">Payment complete, invoice <router-link :to="'/credit/history/' + invoiceId" style="color: inherit; text-decoration: underline">{{invoiceId}}</router-link> has been saved to your invoices history.</div>
    </div>
  
      <div 
        v-loading="!verification"
        element-loading-spinner="qc-spinner">   
    <div v-if="resolvedResult == 'NOT_FOUND'" class="col-md-12 text-danger">     
      <h4 style="margin-top: 0">Your action is required!</h4>
      <p>We have searched the data we hold for this institute, but no match for your request could be found.</p>
      <p>
        Common reasons you may be seeing this include;
        <ul>
          <li>Wrong surname entered due to changed marital status.</li>
          <li>First name shortened instead of using the correct full version (eg Tom instead of Thomas).</li>
          <li>Date of birth incorrectly entered.</li>
          <li>Small typos in candidate / customer ref number.</li>
        </ul>
      </p>
      <p>Please check the details carefully ensuring they match the individual's <i>at the time of attendance</i> and re-submit it below for free.</p>
      <p v-if="verification && verification.institute.allowsPending">Alternatively, after reviewing the details below you may send this request for manual checking.</p>
    </div>
    <div v-else-if="resolvedResult == 'REJECTED'" class="col-md-12 text-danger">
      <h4 style="margin-top: 0">Your action is required!</h4>
      <p>This request has been rejected by the {{who}}. Please update this request with further or correct information before re-submitting it below for free.</p>
      <p>The {{who}} has included the following message:</p>
      <blockquote>{{verification ? verification.notes : null}}</blockquote>
    </div>
    <div v-else-if="resolvedResult == 'UNPAID' || resolvedResult == 'AWAITING_CONSENT'" class="col-md-12 text-warning">
      <h4 style="margin-top: 0">Incomplete!</h4>
      <p>This request is incomplete, please complete and submit it below.</p>
    </div>
    -->
    <transition-group name="el-fade-in-linear" mode="out-in">

      <div key="TRUSTID" v-if="trustIdActionable" class="col-md-12 card">
        
        <step-navigation :steps="steps" :currentStep="currentStep" />
        <div class="card-content row ">
          <div class="row">
            <div class="col-lg-4 col-md-12 col-sm-12">
              <h4 class="text-center">Please use your mobile to verify your identity.</h4>
              <p class="text-center">Scan the QR with your camera to get started.</p>
              <p class="text-center"><img src="https://cdndev.trustid.co.uk/img/icon-phone-id.svg" alt="A generic phone and ID check indicating approval"></p>
            </div>
            <div class="col-lg-4 col-md-12 col-sm-12">
              <div class="card card-blue" style="margin: 10px; padding: 10px;">
                <div class="card-body">
                  <div class="card" style="margin: 10px; padding: 10px;">
                    <div class="card-body">
                      <div class="row">
                        <p class="text-center"><qrcode-vue :value="verification.supplierUrl" :size="200" /></p>
                        <p class="text-center">Scan the QR with your mobile camera</p>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <p class="text-center" style="color: white">Or tap below to start your identity check.</p>
                    <p class="text-center"><button @click.prevent="followLinkNewTab(verification.supplierUrl)" type="button" class="btn btn-wd btn-fill"><i class="fa fa-external-link"></i>&nbsp;Start</button></p>
                    <p class="text-center" style="color: white; margin-left: 10px; margin-right: 10px">When you scan or tap you will be transferred to our trusted identity check partner.</p>
                  </div>
                </div>
              </div>
            </div>
            
            <div class="col-lg-4 col-md-12 col-sm-12" v-loading="loadingResult" element-loading-spinner="qc-spinner" element-loading-text="Checking ...">
              <h4 class="text-center">Checking for identity submission.</h4>
              <!--<p class="text-center">We will check again soon that our identity partner has received your identity documents.</p>-->
              <p class="text-center">This page will refresh after our identity partner has notified us they have received your document submission.</p>
              <!--<p class="text-center">When we receive notification from our identity partner that they have received your submission we will update this page again soon.</p>-->
              <p class="text-center" style="border-radius: 50%; border: 2px solid #cfcfca; height: 100px; width: 100px; line-height: calc(100px - 8px); font-size: 500%; margin: 0 auto; position: relative; border-color: #a1dbde; color: #a1dbde;">
                <i class="fa fa-cog fa-spin" style="width: auto;"></i>
              </p>
              <h2 class="text-center">{{countdownSeconds}}</h2>
              <div class="text-center help-block">seconds until checking</div>
              <div class="text-center help-block">If you have submitted your identity documents to our partner you do not need to wait.</div>
              <p class="text-center"><button  type="button" class="btn btn-wd btn-sm"><i class="fa fa-reply"></i>&nbsp;Return to Wallet</button></p>
            </div>
          </div>
          <!--
          <div class="row col-md-10 col-md-offset-1">
            <div data-notify="container" class="col-md-12 alert alert-warning alert-with-icon">
              <span data-notify="icon" class="fa fa-exclamation"></span>
              <span data-notify="message">Please note it may take up to 10 minutes for our trusted identity check partner to notify us they have received your identity documents after you've uploaded them. Once you have completed the below steps, please return to your I'm Verified Wallet.</span>
            </div>
          </div>
          -->
        </div>
      </div>
      <div key="ACTION" v-else-if="actionable">
        <div class="col-md-12 card" :data-background-color="'warning'">
          <div class="card-header noprint">
              <span class="pull-right" style="font-size: 80%">QCID: {{verification.id}}</span>
              <h4 v-if="resolvedResult == 'UNPAID' || resolvedResult == 'AWAITING_CONSENT'" class="card-title">Incomplete</h4>
              <h4 v-else-if="resolvedResult == 'NOT_FOUND' || resolvedResult == 'REJECTED'" class="card-title">Your action is required!</h4>
          </div>
          <div class="card-content row ">
            <div v-if="resolvedResult == 'NOT_FOUND'" key="NOT_FOUND"  class="col-md-12" >
              <p>We have searched the data we hold for this institute, but no match for your request could be found.</p>
              <p>
                Common reasons you may be seeing this include;
                <ul>
                  <li>Wrong surname entered due to changed marital status.</li>
                  <li>First name shortened instead of using the correct full version (eg Tom instead of Thomas).</li>
                  <li>Date of birth incorrectly entered. Ensure international standard DD/MM/YYYY format is used.</li>
                  <li>Small typos in candidate / customer ref number.</li>
                </ul>
              </p>
              <p>Please check the details carefully ensuring they match the individual's <i>at the time of attendance</i> and re-submit it below for free.</p>
              <p v-if="newVerification && newVerification.institute.allowsPending">Alternatively, after reviewing the details below you may send this request for manual checking.</p>
            </div>
            <div v-else-if="resolvedResult == 'REJECTED'" key="REJECTED" class="col-md-12">
              <p>This request has been rejected by the {{who}}. Please update this request with further or correct information before re-submitting it below for free.</p>
              <p>The {{who}} has included the following message:</p>
              <blockquote>{{verification ? verification.notes : null}}</blockquote>
            </div>
            <div v-else-if="resolvedResult == 'UNPAID' || resolvedResult == 'AWAITING_CONSENT'" key="AWAITING" class="col-md-12">
              <p>This request is incomplete, please complete and submit it below.</p>
            </div>
          </div>
        </div>
        <verification 
          v-if="fullyLoaded"
          v-loading="loadingVerification"
          element-loading-spinner="qc-spinner" 
          :verification="newVerification" 
          :permissions="permissions"
          :documentDeleteData="documentDeleteData"
          :additionalDocsAllowed="resolvedResult == 'REJECTED' ? 5 : newVerification.institute.maxAdditionalDocs">

          <div 
            slot="actions"
            slot-scope="props"
            v-loading="loadingVerification"
            element-loading-spinner="qc-spinner" 
            :class="{'col-md-12 card': !($store.state.paymentType == 'INVOICE' && (verification.result == 'AWAITING_CONSENT' || verification.result == 'UNPAID'))}">
            <div v-if="$store.state.paymentType == 'CARD' && (verification.result == 'AWAITING_CONSENT' || verification.result == 'UNPAID')">
              <payment 
                :inflow="true"
                :inview="true"
                :verifications="[newVerification]"
                @pay="submitAndPay" 
                @deleteVerification="deleteVerification" />
            </div>
            <div v-else class="card-header">
              <h4 class="card-title">Actions</h4>
              <div class="category">The following actions are available for this verification request. <span v-if="!(verification.result == 'AWAITING_CONSENT' || verification.result == 'UNPAID')">You will not be charged for any of these actions.</span> You can return to this page at any stage, your request has already been saved.</div>
              <small class="text-danger" v-if="!props.valid">
                Please resolve the errors above.
              </small>
            </div>
            <div class="form-horizontal">
              <div v-if="verification.result == 'NOT_FOUND'" class="form-group">
                <div class="col-sm-11 col-sm-offset-1">
                  <p class="form-control-static text-danger"><button @click.prevent="reSubmitVerification(false)" type="button" v-bind:disabled="!props.valid" v-bind:class="{'btn-disabled': !props.valid}" class="btn btn-wd btn-fill"><i class="fa fa-repeat"></i>&nbsp;Re-submit</button></p>
                  <span class="help-block">Re-submit this verification request to be checked automatically, including any updates. You may do this <span class="label label-danger">{{verification.retriesLeft}}</span> more time(s).</span>
                </div>
              </div>
              <div v-if="verification.result == 'NOT_FOUND' && newVerification.institute.allowsPending" class="form-group">
                <div class="col-sm-11 col-sm-offset-1">
                  <p class="form-control-static text-danger"><button @click.prevent="reSubmitVerification(true)" type="button" v-bind:disabled="!props.valid" v-bind:class="{'btn-disabled': !props.valid}" class="btn btn-wd btn-fill"><i class="fa fa-share"></i>&nbsp;Send for manual checking</button></p>
                  <span class="help-block">Send this verification request for manual checking. The request will be pending whilst checking takes place. Use this if you are sure the request details are correct.</span>
                </div>
              </div>
              <div v-if="verification.result == 'REJECTED'" class="form-group">
                <div class="col-sm-11 col-sm-offset-1">
                  <p class="form-control-static text-danger"><button @click.prevent="reSubmitVerification(false)" type="button" v-bind:disabled="!props.valid" v-bind:class="{'btn-disabled': !props.valid}" class="btn btn-wd btn-fill"><i class="fa fa-repeat"></i>&nbsp;Re-submit</button></p>
                  <span class="help-block">Re-submit this amended verification request in response to the message from the {{who}} above.</span>
                </div>
              </div>
              <div v-if="$store.state.paymentType != 'CARD' && verification.result == 'AWAITING_CONSENT' || verification.result == 'UNPAID'" class="form-group">
                <div class="col-sm-11 col-sm-offset-1">
                  <p class="form-control-static text-danger"><button @click.prevent="submitAndPay" type="button" v-bind:disabled="!props.valid" v-bind:class="{'btn-disabled': !props.valid}" class="btn btn-wd btn-fill"><i class="fa fa-check"></i>&nbsp;Submit</button></p>
                  <span class="help-block">Submit this completed verification request for processing.</span>
                </div>
              </div>
            </div>
          </div>
        </verification>
      </div>
      <div key="NOACTION" v-else class="col-md-12 card">
        <div class="card-header noprint">
          <h4 class="card-title">Result</h4>
          <div class="category">Your verification request result is below</div>
        </div>
        <div class="card-content row ">
          <result 
            key="OTHERWISE" 
            :result="resolvedResult" 
            :notes="verification ? verification.notes : null" 
            :thirdPartyData="verification ? verification.fields['thirdPartyData'] : null"
            :verification="newVerification" /> 
        </div>
      </div>
    </transition-group>
    <!-- <sharing-center v-if="$store.state.isIndividual && verification && verification.result == 'VERIFIED'" :verification="verification"/> -->
    <verification-timeline v-if="verification && verification.auditEvents && verification.auditEvents.length > 0 && !trustIdActionable" :events="verification.auditEvents" />
  </div>
</template>

<script>
  import Result from 'src/views/Verifications/components/Result'
  import Verification from 'src/views/Verifications/components/Verification'
  import VerificationTimeLine from 'src/views/Verifications/components/VerificationTimeLine'
  import Payment from 'src/views/Credit/components/Payment'
  import SharingCenter from 'src/views/Verifications/components/SharingCenter'
  import StepNavigation from 'src/components/Steps/StepNavigation'
  
  import QrcodeVue from 'qrcode.vue'
  
  import ModalOptions from 'src/components/ModalPlugin/ModalOptions'

  import { Loading } from 'element-ui'

  import moment from 'moment'
  
  export default {
    name: "verification-view",
    components: {
      Result,
      StepNavigation,
      Verification,
      Payment,
      QrcodeVue,
      'sharing-center': SharingCenter,
      'verification-timeline': VerificationTimeLine
    },
    props: {
      id: String,
      result: String,
      inner: Boolean,
      readOnly: {type: Boolean, default: false}
    },
    data () {
      return {
        loadingResult: true,
        loadingVerification: true,
        verification: null,
        newVerification: null,
        invoiceId: null,
        currentStep: 55,
        countdownSeconds: 0
      }
    },
    mounted: function () {
      if(this.$route.query.invoiceId) {
        this.invoiceId = this.$route.query.invoiceId
      }
      this.loadingResult = true
      this.loadingVerification = true
      this.$api.getVerification(this.id)
        .then(response => {
          response.data.invoiceId = this.invoiceId
          this.build(response.data)
        })
        .catch(error => {
          console.log(error)
          this.loadingResult = false
          this.loadingVerification = false
        })
    },
    watch: {
      trustIdActionable: {
        handler(value) {
          if(value) {
            this.countdownSeconds = 120
          }
        }
      },
      countdownSeconds: {
        handler(value) {
          if(this.trustIdActionable) {
            if (value > 0) {
              setTimeout(() => {
                  this.countdownSeconds--;
              }, 1000);
            } else {
              this.loadingResult = true
              this.loadingVerification = true
              this.$api.getVerification(this.id)
                .then(response => {
                  response.data.invoiceId = this.invoiceId
                  this.build(response.data)
                  this.countdownSeconds = 30
                })
                .catch(error => {
                  console.log(error)
                  this.loadingResult = false
                  this.loadingVerification = false
                })
            }
          }
        }
      }
    },
    computed: {
      allowedTypes() {
        if(this.application != null && this.application.allowedTypes) {
          return JSON.parse(this.application.allowedTypes).map(type => type.key)
        }
        return this.$store.getters.allowedTypes
      },
      steps() {
        var steps = []
        
        if(this.application) {
          steps.push({
              id: 0,
              title: "Application Details",
              icon_class: "ti-clipboard"
          })
        }
        if(this.allowedTypes.length > 1) {
          steps.push({
                id: 10,
                title: "Start",
                icon_class: "fa fa-play"
            })
        }
        steps.push({
              id: 15,
              title: "Verification Details",
              icon_class: "fa fa-th-list"
          })
        if(this.$store.state.paymentType == 'CARD') {
          steps.push({
              id: 50,
              title: "Payment Details",
              icon_class: "fa fa-credit-card"
          })
        }
        steps.push({
            id: 55,
            title: "Verify Identity",
            icon_class: "fa fa-mobile"
        })
        steps.push({
            id: 60,
            title: "View Result",
            icon_class: "fa fa-graduation-cap"
        })
        return steps;
      },
      permissions () {
        if(this.verification)  {
          switch (this.verification.result) {
            case "NOT_FOUND": return 8
            case "REJECTED": return 56
            case "UNPAID": return 56
            case "AWAITING_CONSENT": return 56
          }
        }
        return 0
      },
      fullyLoaded () {
        return this.verification != null && this.newVerification != null && this.newVerification.institute != null
      },
      trustIdActionable() {
        if(this.verification != null && this.verification.instituteId == 'QC_ID_VER_TRUST_ID' && this.verification.result == 'NOT_FOUND') { // TODO HACK FOR TRUSTID
          return true
        }
      },
      actionable () {
        return !this.readOnly && this.verification != null && (this.verification.result == 'NOT_FOUND' || this.verification.result == 'REJECTED' || this.verification.result == 'UNPAID' || this.verification.result == 'AWAITING_CONSENT')
      },
      resolvedResult() {
        return this.verification ? this.verification.result : this.result
      },
      who() {
        var who = 'Institute\'s records staff'
        if(this.verification && this.$service.isEmp(this.verification.instituteId)) {
          who = 'Organisation'
        }
        return who
      }
    },
    methods: {
      followLinkNewTab(link) {
        window.open(link, "_blank")
      },
      build(verification) {
        this.verification = verification
        this.invoiceId = verification.invoiceId
        this.loadingResult = false
        this.$service.buildInstitute(this.verification.instituteId, this.verification)
          .then(response => {
            var builtVerification = this.$service.buildVerification(verification)
            if(builtVerification.additionalFieldData) {
              builtVerification.additionalFieldData.forEach(o => {
                if(o.subjects) {
                  builtVerification.subjects = o.subjects
                }
              })
            }
            builtVerification.thirdPartyActionUrl = verification.supplierUrl
            builtVerification.institute = response
            this.newVerification = builtVerification
            this.loadingVerification = false
          })
          .catch(error => {
            console.log(error)
            this.loadingVerification = false
          })
      },
      // documentDeleteData (document) {
      //   return this.$api.deleteDocument(document.verificationId, document.id)
      // },
      documentDeleteData (document) {
        return new Promise((resolve, reject) => {
          // Nothing to do particularly
          resolve()
        })
      },
      formatDate(date) {
        return moment(date, 'DD/MM/YYYY').format('YYYY-MM-DD')
      },
      deleteVerification () {
        this.$modal.show(ModalOptions,
          {
            title: "Delete Verification",
            message: "Are delete this verification request?",
            closeText: "Cancel",
            actionText1: "Delete",
            actionIcon1: "fa fa-trash",
            action1: () => 
              {
                this.$api.deleteVerification(this.verification.id)
                this.$router.push('/verification/history')
                this.$modal.close()
              }
            }
          )
      },
      reSubmitVerification (pushToPending) {
        this.$validator.validate().then((result) => {
          if(result) {
            var loading = Loading.service({
              spinner: 'qc-spinner',
              text: 'Updating verification'
            })

            var newVerification = this.$service.buildVerificationSubmission(this.newVerification, null)
            
            newVerification.retriesLeft = pushToPending ? 0 : this.verification.retriesLeft

            this.$api.putVerification(this.verification.id, newVerification, true, pushToPending)
              .then(response => {
                this.$store.commit('updateMeta')
                this.build(response.data)
                loading.close()
                this.$scrollTo('#contentTop')
              })
              .catch(error => {
                console.log(error)
                loading.close()
                this.$scrollTo('#contentTop')
              })
          } else {
            this.$snotify.error("Please correct the errors shown below.", "Error", {
              timeout: 7500
            })
            this.$scrollTo('#contentTop')
          }
        })
      },
      submitAndPay(creditPurchaseRequest, callback) {
        this.$validator.validate().then((result) => {
          if(result) {
            var loading = Loading.service({
              spinner: 'qc-spinner',
              text: 'Submitting verification(s)'
            })

            this.$api.putVerification(this.verification.id, {
                verifications: [this.$service.buildVerificationSubmission(this.newVerification, null)],
                creditPurchase: creditPurchaseRequest
              })
              .then(response => {
                this.$store.commit('updateMeta')
                var invoiceId = response.data.length > 0 ? response.data[0].invoiceId : response.data.invoiceId
                if(invoiceId) {
                    this.$snotify.success("Invoice " + invoiceId + " has been saved to your invoices history.", "Payment Complete", {
                      timeout: 7500,
                      icon: 'data:image/svg+xml;charset=UTF-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20version%3D%221.1%22%20width%3D%22500%22%20height%3D%22500%22%3E%0A%3Cg%20transform%3D%22translate(0%2C-552.36218)%22%20id%3D%22layer1%22%20%3E%3Cpath%20fill%3D%22%23ffffff%22%20d%3D%22m%20301.29681%2C788.55573%200%2C32.9956%20-81.5918%2C0%20c%205.99351%2C17.19988%208.99033%2C31.20133%208.99048%2C42.0044%20l%200%2C0.60424%20c%20-1.5e-4%2C21.9972%20-11.59682%2C46.79576%20-34.79004%2C74.39576%20-9.20421%2C11.20611%20-21.20371%2C24.20659%20-35.99854%2C39.00146%2023.5961%2C-15.60053%2047.99182%2C-23.40082%2073.18726%2C-23.40088%2014.0013%2C6e-5%2030.40143%2C3.00299%2049.20044%2C9.00879%2021.99685%2C6.39653%2037.79883%2C9.59477%2047.406%2C9.59473%2016.00316%2C4e-5%2032.60471%2C-5.99971%2049.80469%2C-17.99927%20l%2025.19531%2C39.60571%20c%20-22.80303%2C22.39993%20-49.00539%2C33.59983%20-78.60717%2C33.59983%20-17.60277%2C0%20-42.99947%2C-5.603%20-76.19019%2C-16.8091%20l%20-11.40747%2C-4.1931%20c%20-13.19594%2C-4.4067%20-26.39783%2C-6.6101%20-39.60571%2C-6.6101%20-21.1915%2C0%20-42.98713%2C7.4036%20-65.38696%2C22.2107%20l%20-28.8025%2C-39.6057%20c%2040.79584%2C-35.20501%2064.79484%2C-65.40518%2071.99708%2C-90.60058%202.00185%2C-7.20202%203.00283%2C-14.80089%203.00292%2C-22.79664%20-9e-5%2C1.5e-4%20-9e-5%2C-0.20127%200%2C-0.60424%20l%200%2C-0.60425%20c%20-9e-5%2C-15.19759%20-4.80355%2C-30.79816%20-14.4104%2C-46.80176%20l%20-65.991206%2C0%200%2C-32.9956%2048.596196%2C0%20c%20-18.39605%2C-30.39526%20-28.59501%2C-52.19089%20-30.59693%2C-65.38697%20-0.8057%2C-3.60078%20-1.20853%2C-7.60468%20-1.20849%2C-12.01172%20l%200%2C-6.00586%20c%20-4e-5%2C-39.59926%2016.00336%2C-71.99669%2048.01025%2C-97.19238%2026.4037%2C-20.80035%2057.80015%2C-31.20073%2094.18945%2C-31.20117%20l%200.60425%2C0%20c%2045.20242%2C4.4e-4%2080.20604%2C14.80145%20105.01099%2C44.40308%20l%2010.19897%2C14.99633%20c%2010.79072%2C18.39636%2016.38763%2C44.99545%2016.79077%2C79.79737%20l%20-52.7893%2C0%20c%20-1.59938%2C-61.59632%20-28.80272%2C-92.39463%20-81.61011%2C-92.39502%20-35.59584%2C3.9e-4%20-60.59582%2C12.59803%20-75%2C37.79297%20-6.39658%2C11.20639%20-9.59482%2C24.01156%20-9.59473%2C38.41552%20l%200%2C0.58594%20c%20-9e-5%2C15.21026%204.40054%2C31.21366%2013.20191%2C48.01025%20l%200%2C0.60425%200.60424%2C0.58594%20c%201.59902%2C3.60134%203.79629%2C8.00197%206.5918%2C13.2019%20l%205.40161%2C9.00879%209.59473%2C16.79078%20z%22%20%2F%3E%3C%2Fg%3E%0A%3C%2Fsvg%3E'
                    })
                    this.$store.commit('addUnseenInvoice')
                }
                this.build(response.data)
                this.$scrollTo('#contentTop')
                loading.close()
              }).catch(error => {
                console.log(error)
                loading.close()
                callback(false)
              })
          } else {
            this.$snotify.error("Please correct the errors shown below.", "Error", {
              timeout: 7500
            })
            this.$scrollTo('#contentTop')
            callback(false)
          }
        })
    }
  }
}
</script>

<style>
.fa-spin {
  animation-duration: 4s; 
}
</style>